import { render, staticRenderFns } from "./noticeManage.vue?vue&type=template&id=9ed9e7c4"
import script from "./noticeManage.vue?vue&type=script&lang=js"
export * from "./noticeManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ed9e7c4')) {
      api.createRecord('9ed9e7c4', component.options)
    } else {
      api.reload('9ed9e7c4', component.options)
    }
    module.hot.accept("./noticeManage.vue?vue&type=template&id=9ed9e7c4", function () {
      api.rerender('9ed9e7c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/notice/noticeManage.vue"
export default component.exports